import React, { useEffect, useState } from "react";
import {
  Button,
  CloseButton,
  Modal,
  Form,
  Row,
  Col,
  Nav,
  Tab,
} from "react-bootstrap";
import { useClinicStore } from "./store";
import { toast } from "react-toastify";
import _ from "lodash";
import { useNotificationStore } from "modules/navbar/top/store";
import { debounce } from "lodash";
import { formatPhoneNumber } from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";
import { shuffle } from "lodash";
import { isEmpty } from "lodash";
import { size } from "lodash";

const OnBoardCX = ({
  show,
  setIsModalVisible,
  startDate,
  endDate,
  phoneNumber = null,
  setPhoneNumber = () => {}
}) => {
  const {
    getClinicSlots,
    slots = {},
    bookClinicSlotsStore,
    locations = [],
    getClinicLocations,
  } = useClinicStore();
  const [doctor, setDoctor] = useState([]);
  const { searchResult, fetchCaseData } = useNotificationStore();
  const [showSlots, setShowSlots] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    gender: "",
    location: "",
  });
  const debouncedFetchCaseData = debounce((text) => {
    const searchText = formatPhoneNumber(text);
    fetchCaseData(searchText);
  }, 500);

  useEffect(() => {
    if(isEmpty(phoneNumber)){
      setFormData((prev) => ({
        name: "",
        email: "",
        gender: "",
        phone_number: "",
      }));
    }
  }, [phoneNumber])

  useEffect(() => {
    if (formData.phone_number || phoneNumber) {
      (formData.phone_number ||phoneNumber) && debouncedFetchCaseData(formData.phone_number || phoneNumber);
    } else {
      resetForm();
    }
    return () => debouncedFetchCaseData.cancel();
  }, [formData.phone_number, phoneNumber]);

  useEffect(() => {
    if (slots.doctorSlots && slots.doctorSlots.length > 0) {
      setSelectedSlot(null);
      setShowSlots(true);
    } else {
      setShowSlots(false);
    }
  }, [slots]);

  useEffect(() => {
    if ((!_.isEmpty(searchResult) && formData?.phone_number) || phoneNumber) {
      const data = _.get(searchResult, "0", []);
      setFormData((prev) => {
        return {
          ...prev,
          name: data.first_name,
          email: data.email,
          phone_number: data.phone_number,
          gender: data.gender,
        };
      });
    } else {
      resetForm();
    }
  }, [searchResult]);

  const resetForm = () => {
    setFormData((prev) => ({
      name: "",
      email: "",
      gender: "",
      phone_number: prev.phone_number,
    }));
    setPhoneNumber(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClose = () => {
    setIsModalVisible(false);
    setSelectedSlot(null);
    setShowSlots(false);
    resetForm();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let payload = { ...formData, phone_number: `+91${formData.phone_number.slice(-10)}`, gender: "M" };
    getClinicSlots(payload, toast);
  };

  useEffect(() => {
    getClinicLocations();
  }, []);

  const handleSlotSelection = (slot) => {
    setDoctor(shuffle(slot.slots.users));
    setSelectedSlot(slot.slotTime);
  };

  const handleSlotBooking = () => {
    if (selectedSlot) {
      let payload = {
        case_id: slots.case_id,
        slot_time: selectedSlot,
        clinic_id: formData.location,
        user_id: doctor[0],
        from_crm: true,
      };
      if(phoneNumber){
        payload = {...payload, is_reschedule: true}
      }
      bookClinicSlotsStore(
        payload,
        formData.location,
        toast,
        startDate,
        endDate
      );
      resetForm();
      handleClose();
    }
  };

  const groupSlotsByDate = () => {
    if (!slots.doctorSlots) return {};
    return slots.doctorSlots.reduce((acc, slot) => {
      const date = new Date(slot.slotTime).toLocaleDateString();
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(slot);
      return acc;
    }, {});
  };

  const renderSlots = (slots) => {
    return slots.map((slot) => {
      const slotTime = new Date(slot.slotTime);
      const formattedTime = slotTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });

      return (
        <Button
          key={slot.slotTime}
          variant={
            selectedSlot === slot.slotTime ? "primary" : "outline-primary"
          }
          className={
            slot.slots.count === 0 ? "bg-secondary text-white m-1" : "m-1"
          }
          disabled={slot.slots.count === 0}
          style={{ width: "70px" }}
          onClick={() => handleSlotSelection(slot)}
        >
          {formattedTime}
        </Button>
      );
    });
  };

  const groupedSlots = groupSlotsByDate();

  return (
    <Modal
      show={show}
      onHide={() => handleClose()}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Book Appointment
        </Modal.Title>
        <CloseButton
          className="btn btn-circle btn-sm transition-base p-0"
          onClick={() => handleClose()}
        />
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formPhoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formAge">
              <Form.Label>Gender</Form.Label>
              <Form.Select
                aria-label="Default select Gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option>Please Select Gender</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} xs={12} sm={6} md={4} lg={4} controlId="formLocation">
              <Form.Label>Select Location</Form.Label>
              <Form.Select
                aria-label="Default select location"
                name="location"
                value={formData.location}
                onChange={handleChange}
              >
                <option>Please Select Location</option>
                {
                  locations.map(el => (<option value={el.clinic_id}>{el.locality}</option>))
                }
              </Form.Select>
            </Form.Group>
          </Row>
          <Button variant="primary" type="submit" className="mt-3">
            Get Slots
          </Button>
        </Form>
        {showSlots && (
          <Tab.Container defaultActiveKey={Object.keys(groupedSlots)[0]}>
            <Nav variant="tabs" className="mt-4">
              {Object.keys(groupedSlots).map((date, index) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    className="border border-bottom-0 shadow-sm"
                    eventKey={date}
                  >
                    {date}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            <Tab.Content
              className="border border-top-0 rounded"
              style={{ minHeight: "15rem" }}
            >
              {Object.keys(groupedSlots).map((date, index) => (
                <Tab.Pane eventKey={date} key={index}>
                  <div className="d-flex flex-wrap mt-3">
                    {renderSlots(groupedSlots[date])}
                  </div>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        )}
      </Modal.Body>
      <Modal.Footer>
        {selectedSlot && (
          <Button variant="primary" onClick={handleSlotBooking}>
            Book Appointment
          </Button>
        )}
        <Button variant="danger" onClick={() => handleClose()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OnBoardCX;
